import { Form } from './form';
export { Form };
export default Form;
//# sourceMappingURL=index.js.map